import { Fragment, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonServiceCrumbs } from 'system/constants/common-service-crumbs';
import OperatorDetail from 'system/components/operators/detail';
import { useParams, useNavigate, generatePath } from 'react-router';

const OperatorDetailPageServiceDetail = (): React.ReactElement => {
  const params = useParams();
  const navigate = useNavigate();

  const onCancel = useCallback(() => {
    navigate(generatePath('/sistema/servizi/dettaglio/:id', params));
  }, [navigate]);

  return (
    <Fragment>
      <Breadcrumbs
        items={[
          ...CommonServiceCrumbs,
          { name: 'Dettaglio Servizio', path: '/sistema/servizi/dettaglio/:id' },
          { name: 'Dettaglio Operatore' },
        ]}
      />
      <OperatorDetail onCancel={onCancel} id={params.idOperatore} />
    </Fragment>
  );
};

OperatorDetailPageServiceDetail.displayName = 'Operator Edit page component from service detail';

export default OperatorDetailPageServiceDetail;
